module.exports = __webpack_public_path__ + "staticcomp/img/cover.91b975d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/4/cover.jpg
// module id = VHRS
// module chunks = 39